module.exports = __webpack_public_path__ + "img/new-logo.65c8176d.svg";